import { useEffect, useRef, useState } from "react";
import { ADMIN_ITEMS } from "@/views/admin/items";

export function AdminMenu({ onNav, onLogout }) {
  const [open, setOpen] = useState(false);
  const [left, setLeft] = useState(false);
  const ref = useRef(null);
  const toggle = () => { setLeft(ref.current.getBoundingClientRect().right < 260); setOpen(o => !o); };
  useEffect(() => {
    if (!open) return undefined;
    const away = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const esc = e => { if (e.key === "Escape") { setOpen(false); ref.current.querySelector("button").focus(); } };
    document.addEventListener("mousedown", away);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", away); document.removeEventListener("keydown", esc); };
  }, [open]);
  const go = (e, path) => { e.preventDefault(); setOpen(false); onNav(path); };
  return (
    <div className="adm-menu" ref={ref}>
      <button className="signout" aria-haspopup="menu" aria-expanded={open} onClick={toggle} data-testid="admin-menu-btn">
        Admin <span className="adm-caret" aria-hidden="true">▾</span>
      </button>
      {open ? (
        <div className={"adm-pop" + (left ? " left" : "")} role="menu" data-testid="admin-menu">
          {ADMIN_ITEMS.map(i => (
            <a key={i.id} role="menuitem" href={i.path} onClick={e => go(e, i.path)} data-testid={`admin-menu-item-${i.id}`}>
              <b>{i.label}</b><span>{i.desc}</span>
            </a>
          ))}
          <button role="menuitem" className="adm-pop-signout" onClick={() => { setOpen(false); onLogout(); }} data-testid="admin-menu-signout">Sign out</button>
        </div>
      ) : null}
    </div>
  );
}
